import axios from "axios";
import { apiUrl, getAuthHeader } from "./base";
import { DEFAULT_SELECT_OPTION } from "../../config/constants";

type TOptionItem = {
  label: string;
  value: any;
};

const getOptionsByGroup = async (groupId: string, role: string = "") => {
  let options: TOptionItem[] = [DEFAULT_SELECT_OPTION];

  try {
    let targetUrl = `/apiuser/members/${groupId}?role=${role}`;
    let res = await axios.get(apiUrl(targetUrl), await getAuthHeader());
    let resData = res.data;
    if (resData.result === "OK" && Array.isArray(resData.data)) {
      let members = resData.data;
      options = members.map((member) => ({
        label: member.email,
        value: member._id,
      }));
    }
  } catch {
    //ignore
  }

  return options;
};

const getSupervisedStudents = async (supervisorId: string, groupId: string) => {
  let result: any[];

  try {
    let targetUrl = `/apisupervision/supervisedBy/${supervisorId}/${groupId}`;
    let res = await axios.get(apiUrl(targetUrl), await getAuthHeader());
    let resData = res.data;
    if (resData.result === "OK" && Array.isArray(resData.data)) {
      result = resData.data;
    }
  } catch {
    //ignore
  }

  return result;
};

const ApiMember = {
  getOptionsByGroup,
  getSupervisedStudents,
};

export default ApiMember;
